import React from 'react';

import { DEFAULT_PRECISION, formatNumber } from '@make-software/cspr-ui';
import Big from 'big.js';

export interface CurrencyAmountProps {
  amount: string | null;
  decimals?: number;
  symbol?: string;
  precision?: number;
}

export function CurrencyAmount({
  amount,
  decimals,
  symbol = '',
  precision = DEFAULT_PRECISION,
}: CurrencyAmountProps) {
  if (amount == null) {
    return <>{'N/A'}</>;
  }

  const tokenDivider = (decimals) => Big(10).pow(decimals);
  const calculatedAmount: string = decimals
    ? Big(amount).div(tokenDivider(decimals)).toString()
    : Big(amount || 0).toString();

  const formattedAmount = formatNumber(calculatedAmount, {
    precision,
  });
  const formattedText = formattedAmount + ` ${symbol}`;

  return <>{formattedText}</>;
}

export default CurrencyAmount;
